import React, {Component, Fragment} from 'react';
import { compose } from "redux";
import { connect } from "react-redux";
import _ from "lodash";
import styled from 'styled-components';
import {TextField, Grid} from '@material-ui/core';
import Check from "@material-ui/icons/Check";
import InputAdornment from '@material-ui/core/InputAdornment';

import { getCurrentCapCalcSettings, updateCapCalcSettings} from "store/state/capCalcSettings";

import {CancelButton, SecondaryButton} from 'components/Global/Buttons';
import SimpleConfirmDialog from 'components/Global/ConfirmationDialogs/SimpleConfirmDialog';
import {
    NoDecimalPercentFormat,
    TwoDecimalPercentFormat,
    ThreeDecimalPercentFormat,
    FourDecimalPercentFormat,
    FiveDecimalPercentFormat,
    FiveDecimalFloatFormat,
    ThreeDecimalFloatFormat,
    TwoDecimalFloatFormat,
    FloatFormat,
    DollarFormat
} from 'components/Notifications/FormattedInputs';



class CapCalculatorSettings extends Component{
    state ={        
        isCancelModalOpen:false
    }

    onChangeRiskFreeRate = (event) => {
        this.props.capCalcSettings.riskFreeRate = event.target.value/100; //this is a percent so /100
    }

    onChanageCapSize = (event) => {
        this.props.capCalcSettings.capSize = event.target.value;
    }

    onChangeNotionalAdjustment = (event) => {
        this.props.capCalcSettings.notionalAdjustment = event.target.value/100;
    }

    openCancelModal = () => this.setState({isCancelModalOpen: true})    
    closeCancelModal = () => this.setState({isCancelModalOpen: false})

    componentDidMount(){
        this.props.getCurrentCapCalcSettings();
    }


    renderButtons = () => {
        return (
        <Fragment>
            <CancelButton onClick={this.openCancelModal}/>
            <SecondaryButton onClick={this.saveSettings}>
              <Check />
              <div>Save Settings</div>    
            </SecondaryButton>       
        </Fragment>
              
        );            
      }

      saveSettings = () => {
          this.props.updateCapCalcSettings(this.props.capCalcSettings);
      }

      renderInputField = (fieldName, doShowPlaceholder, doShowHelperText, value, onChange, type) =>{
        let placeholder = "";
        let helperText = null;
        if(doShowPlaceholder){
            placeholder = fieldName;
        }
        if(doShowHelperText){
            helperText = fieldName;
        }
        let inputProps = {};
        inputProps.disableUnderline=true;
        inputProps.style={
        borderBottom: '1px solid #2196F3',    
        transition: '0.3s',
        }
        let defaultValue = value;
        switch(type){
            case 'money':
                inputProps.inputComponent=DollarFormat;
                break;   
            case 'percent':
                defaultValue = value*100;
                inputProps.inputComponent=NoDecimalPercentFormat;
                inputProps.style.width="125px";
                break;
            case 'fourdecimalpercent':
                defaultValue = value*100;
                inputProps.inputComponent=FourDecimalPercentFormat;
                inputProps.style.width="160px";
                break;
            case 'twodecimalfloat':
                inputProps.inputComponent=TwoDecimalFloatFormat;
                break;
            default:
                inputProps.inputComponent=ThreeDecimalFloatFormat;
                break;
        }
          return(
              <Grid>
                <TextField
                    disableUnderline
                    onChange={onChange}
                    defaultValue = {defaultValue}
                    placeholder = {placeholder}
                    helperText = {helperText}
                    id={"inputFor"+fieldName}
                    InputProps={inputProps}
                /> 
            </Grid>
          )
      }

      renderStrikeBasedRows = (strikeBasedAdjustments) =>{
        let obj = [];
        for(let i=0; i<strikeBasedAdjustments.length; i++){
                 obj.push(this.createStrikeBasedRowForGivenRecord(strikeBasedAdjustments[i]))
                }         
        return obj;
      } 
      
      createStrikeBasedRowForGivenRecord = (adjustment) =>{
        let givenPercent = adjustment.strike*100;
          return(
                <tr>
                    <DataCell>{`${givenPercent.toFixed(2)}%`}</DataCell>
                    <DataCell>{this.renderInputField(`Vol Adjust (${givenPercent.toFixed(2)}%)`,false,false,adjustment.vol,
                    //on change method
                    (event)=>{
                        let adjustments = this.props.capCalcSettings.strikeBasedAdjustments;
                        for(let i = 0; i<adjustments.length; i++){
                            if(adjustments[i]===adjustment){
                                adjustments[i].vol = event.target.value;
                                break;
                            }
                        }
                    }, 'twodecimalfloat')}</DataCell>
                    <DataCell>{this.renderInputField(`Minimum (${givenPercent.toFixed(2)}%)`,false,false,adjustment.minimum,
                    //on change method
                    (event)=>{
                        let adjustments = this.props.capCalcSettings.strikeBasedAdjustments;
                        for(let i = 0; i<adjustments.length; i++){
                            if(adjustments[i]===adjustment){
                                adjustments[i].minimum = event.target.value;
                                break;
                            }
                        }
                    }
                    //type
                    ,'money')}</DataCell>
                </tr>
          )
      }


      //gets list of of row elements, one for each rating in the array
      renderRatingAdjustRows = (ratingsBasedAdjustments) =>{
        let obj = [];
        for(let i=0; i<ratingsBasedAdjustments.length; i++){
                obj.push(this.createRatingAdjustRowForRecord(ratingsBasedAdjustments[i]))
            }         
        return obj;
      }

      //creates a row for a given rating 
      createRatingAdjustRowForRecord = (givenRecord) =>{
            let givenRating = givenRecord.rating.name;
          return(
            <tr>
                <DataCell>{givenRating}</DataCell>
                <DataCell>{this.renderInputField(`${givenRating} - month12`,false,false,givenRecord.month12,
                //on change method
                (event)=>{
                    let adjustments = this.props.capCalcSettings.ratingAdjustments;
                    for(let i = 0; i<adjustments.length; i++){
                        if(adjustments[i]===givenRecord){
                            adjustments[i].month12 = event.target.value/100;
                            break;
                        }
                    }
                },'percent')}</DataCell>
                <DataCell>{this.renderInputField(`${givenRating} - month24`,false,false,givenRecord.month24,
                //on change method
                (event)=>{
                    let adjustments = this.props.capCalcSettings.ratingAdjustments;
                    for(let i = 0; i<adjustments.length; i++){
                        if(adjustments[i]===givenRecord){
                            adjustments[i].month24 = event.target.value/100;
                            break;
                        }
                    }
                },'percent')}</DataCell>
                <DataCell>{this.renderInputField(`${givenRating} - month36`,false,false,givenRecord.month36,
                //on change method
                (event)=>{
                    let adjustments = this.props.capCalcSettings.ratingAdjustments;
                    for(let i = 0; i<adjustments.length; i++){
                        if(adjustments[i]===givenRecord){
                            adjustments[i].month36 = event.target.value/100;
                            break;
                        }
                    }
                },'percent')}</DataCell>
                <DataCell>{this.renderInputField(`${givenRating} - month48`,false,false,givenRecord.month48,
                (event)=>{
                    let adjustments = this.props.capCalcSettings.ratingAdjustments;
                    for(let i = 0; i<adjustments.length; i++){
                        if(adjustments[i]===givenRecord){
                            adjustments[i].month48 = event.target.value/100;
                            break;
                        }
                    }
                },'percent')}</DataCell>
                <DataCell>{this.renderInputField(`${givenRating} - month60`,false,false,givenRecord.month60,
                (event)=>{
                    let adjustments = this.props.capCalcSettings.ratingAdjustments;
                    for(let i = 0; i<adjustments.length; i++){
                        if(adjustments[i]===givenRecord){
                            adjustments[i].month60 = event.target.value/100;
                            break;
                        }
                    }
                },'percent')}</DataCell>
                <DataCell>{this.renderInputField(`${givenRating} - month72`,false,false,givenRecord.month72,
                (event)=>{
                    let adjustments = this.props.capCalcSettings.ratingAdjustments;
                    for(let i = 0; i<adjustments.length; i++){
                        if(adjustments[i]===givenRecord){
                            adjustments[i].month72 = event.target.value/100;
                            break;
                        }
                    }
                },'percent')}</DataCell>
                <DataCell>{this.renderInputField(`${givenRating} - month84`,false,false,givenRecord.month84,
                (event)=>{
                    let adjustments = this.props.capCalcSettings.ratingAdjustments;
                    for(let i = 0; i<adjustments.length; i++){
                        if(adjustments[i]===givenRecord){
                            adjustments[i].month84 = event.target.value/100;
                            break;
                        }
                    }
                },'percent')}</DataCell>
                <DataCell>{this.renderInputField(`${givenRating} - Minimum`,false,false,givenRecord.minimum,
                 (event)=>{
                    let adjustments = this.props.capCalcSettings.ratingAdjustments;
                    for(let i = 0; i<adjustments.length; i++){
                        if(adjustments[i]===givenRecord){
                            adjustments[i].minimum = event.target.value;
                            break;
                        }
                    }
                }
                ,'money')}</DataCell>
            </tr>
          )
      }

      renderCancelModel = () => {
        return(
        <SimpleConfirmDialog 
                title="Confirm Cancel"
                message="You are about to cancel all of your changes. Are you sure you want to do this?"
                noText="NO"
                yesText="YES, CANCEL"
                modalOpen={this.state.isCancelModalOpen}
                handleNo={this.closeCancelModal}
                handleYes={() => {
                    window.location.reload(); //reload page to reload default values
                    this.setState({isCancelModalOpen:false})
                }} />  
          )
      }

      renderStrikeBasedTable = (strikeBasedAdjustments) =>{
        return(
        <Fragment>
            <SubTitle>STRIKE-BASED VOL ADJUSTMENT</SubTitle>
            <PrettyTable>
            <GreyHeader>
                <HeaderCell>Strike Adjust</HeaderCell>
                <HeaderCell>Vol Adjust</HeaderCell>
                <HeaderCell>Minimum</HeaderCell>
            </GreyHeader>
                    {this.renderStrikeBasedRows(strikeBasedAdjustments)}
            </PrettyTable>
        </Fragment>
          )
        }

        renderRatingsBasedTable = (ratingsBasedAdjustments) =>{
            return(
                <Fragment>
                    <SubTitle>RATINGS ADJUSTMENT</SubTitle>
                        <PrettyTable>
                        <GreyHeader>
                            <HeaderCell>Rating</HeaderCell>
                            <HeaderCell>12 Mo.</HeaderCell>
                            <HeaderCell>24 Mo.</HeaderCell>
                            <HeaderCell>36 Mo.</HeaderCell>
                            <HeaderCell>48 Mo.</HeaderCell>
                            <HeaderCell>60 Mo.</HeaderCell>
                            <HeaderCell>72 Mo.</HeaderCell>
                            <HeaderCell>84 Mo.</HeaderCell>
                            <HeaderCell>Min</HeaderCell>
                        </GreyHeader>
                            {this.renderRatingAdjustRows(ratingsBasedAdjustments)}
                        </PrettyTable>
                </Fragment>
            )
        }

       renderJumboSection = () =>{
            return(
                <Fragment>
                    <SubTitle>JUMBO CAP VOL ADJUSTMENT</SubTitle>
                    <PrettyTable>
                            <tr>
                                <DataCellNoUnderline>
                                {this.renderInputField("Cap Size",true,true,this.props.capCalcSettings.capSize,this.onChanageCapSize,'money')}                         
                                </DataCellNoUnderline>
                                <DataCellNoUnderline>
                                {this.renderInputField("Notional Adjustment",true,true,this.props.capCalcSettings.notionalAdjustment,this.onChangeNotionalAdjustment,'fourdecimalpercent')}
                                </DataCellNoUnderline>
                            </tr>
                    </PrettyTable>
                </Fragment>
            )
        }


    render() {
        if(!this.props.capCalcSettings){
            return null;
        }
        const strikeBasedAdjustments = _.sortBy(this.props.capCalcSettings.strikeBasedAdjustments,'strike');
        const ratingsBasedAdjustments = _.sortBy(this.props.capCalcSettings.ratingAdjustments,"rating.sortOrder");
        return(
            <Fragment>
                <Title>User Admin  {this.renderButtons()}</Title>
                {this.renderInputField("Risk Free Rate",true,true,this.props.capCalcSettings.riskFreeRate,this.onChangeRiskFreeRate,'fourdecimalpercent')}
                <br/>
                {this.renderJumboSection()}
                <br/><br/><br/>
                {this.renderStrikeBasedTable(strikeBasedAdjustments)}
                <br/><br/><br/>
                {this.renderRatingsBasedTable(ratingsBasedAdjustments)}
                {this.renderCancelModel()}    
            </Fragment>
        )
    }
}




const Title = styled.div`
font-size:24px;
color: #333333;
`

const SubTitle = styled.div`
font-size:18px;
color: #777777;
margin-bottom: 10px;
`

const PrettyTable = styled.table`
border-spacing: 0px;
`

const GreyHeader = styled.tr`
background-color: #f9f9f9;
color: black
`

const DataCell = styled.td`
&& {
padding-left: 10px;
padding-right: 10px;
border-bottom: 1px solid #cccccc;
}
`

const DataCellNoUnderline = styled.td`
&& {
padding-left: 0px;
padding-right: 10px;
}
`

const HeaderCell = styled.th`
&& {
    border-bottom: 3px solid #eeeeee;
    font-weight: normal;
    font-size: 18;
}
`

function mapStateToProps({capCalcSettings}) { 
    return {
        capCalcSettings: capCalcSettings.currentCapCalcSettings,
    }
 }

export default compose(

    connect( mapStateToProps, 
            { 
                getCurrentCapCalcSettings, updateCapCalcSettings
            }
           ),
)(CapCalculatorSettings);